export const publishDraftResponseCodes = {
  ok: 'OK',
  userProfessional: 'USER_PROFESSIONAL',
  maxDeletedAds: 'MAX_DELETED_ADS',
  limitExceeded: 'LIMIT_EXCEEDED',
  freeAdsLimitExceeded: 'FREE_ADS_LIMIT_EXCEEDED',
  userJoker: 'USER_JOKER',
  notPublished: 'NOT_PUBLISHED',
  noCode: 'NO_CODE'
}

export const sendToPaymentAdUrlCodes = [
  publishDraftResponseCodes.userProfessional,
  publishDraftResponseCodes.maxDeletedAds,
  publishDraftResponseCodes.limitExceeded,
  publishDraftResponseCodes.freeAdsLimitExceeded
]

export const sendToUnauthorizedUrlCodes = [publishDraftResponseCodes.userJoker]

export const defaultAnonymousDraft = {
  body: null,
  carPlate: null,
  colour: null,
  comments: null,
  email: null,
  environmentalLabel: 'UNSPECIFIED',
  fuel: null,
  hidePhone: true,
  images: [],
  km: null,
  make: null,
  model: null,
  phone: null,
  plateRegistrationDate: null,
  price: null,
  province: null,
  publishInMA: true,
  transmission: null,
  version: null,
  year: null,
  zipCode: null
}
